// ======================================================================
// File Name       : LivePerformanceDetailInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { onChangeWrapper } from '../../utils/FormUtils';
import { VALIDATE_TYPE, DEFAULT_DATE_FORMAT_SHORT_DETAIL } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import RenderField from '../../utils/ReduxFormUtils';
import PaginationCustom from '../Pagination';
import ReduxFormPaging from '../ReduxFormPaging';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import { LIVE_FORMAT_STR } from '../../constants/LivePerformanceConstants';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';

class LivePerformanceDetailInfo extends React.Component {
  render() {
    const {
    liveList,
    organizerUserName,
    liveStartFrom,
    liveStartTo,
    liveFormat,
    liveDetailObj,
    liveReserveDetail,
    liveName,
    } = this.props;
    return (
      <div>
        <h3>ライブの詳細</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="padding-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                  ライブ名
              </Col>
              <Col sm={9} as={Form.Label}>
                {liveName}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ライブ開催者名
              </Col>
              <Col sm={9} as={Form.Label}>
                {organizerUserName}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                  実施日時
              </Col>
              <Col sm={3} className="lable-value" as={Form.Label}>
                {parseDateForDetail(liveStartFrom, DEFAULT_DATE_FORMAT_SHORT_DETAIL)}
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                    ～
                  </Col>
              <Col sm={3} className="lable-value" as={Form.Label}>
                {parseDateForDetail(liveStartTo, DEFAULT_DATE_FORMAT_SHORT_DETAIL)}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                  ライブ形式
              </Col>
              <Col sm={9} as={Form.Label}>
                {getItemBoxName(LIVE_FORMAT_STR, liveFormat)}
              </Col>
            </Form.Group>
          </Col>
        </Form>
      </div>
    );
  }
}

export default LivePerformanceDetailInfo;
